import React from 'react';
import BookingSubmitButton, {
    BookingSubmitButtonTypes
} from '~components/BookingSubmitButton/BookingSubmitButton';

type BookingSubmitButtonProps = BookingSubmitButtonTypes;

const BookingSubmitButtonContainer = (props: BookingSubmitButtonProps) => (
    <BookingSubmitButton {...props} />
);
export default BookingSubmitButtonContainer;
